/** Cache key shared by Inbox, Sent, Drafts, Compose, and realtime updates. */
export const MESSAGES_QUERY_KEY = ["messages"] as const;
export const NOTIFICATIONS_QUERY_KEY = ["notifications", "inbox"] as const;
export const AGENT_ACTIONS_QUERY_KEY = ["agent-actions"] as const;

/** Server-backed mailbox surfaces use distinct roots so state changes never
 *  refetch the unrelated label library. */
export const MAILBOX_THREADS_QUERY_KEY = ["mailbox", "threads"] as const;
export const MAILBOX_LABELS_QUERY_KEY = ["mailbox", "labels"] as const;
export const MAILBOX_SUMMARY_QUERY_KEY = ["mailbox", "summary"] as const;

/** Membership-filtered chat surfaces and case inboxes. */
export const CHAT_QUERY_KEY = ["kardoe-chat", "conversations"] as const;
export const CASES_QUERY_KEY = ["kardoe-cases"] as const;

/** Canonical full-directory snapshots. Every screen and picker must share
 * these exact keys so a successful mutation can update one authoritative
 * client cache instead of leaving parallel copies stale. */
export const CONTACTS_QUERY_KEY = ["contacts"] as const;
export const COMPANIES_QUERY_KEY = ["companies"] as const;
export const LEADS_QUERY_KEY = ["leads"] as const;

export type DirectoryEntity = "contacts" | "companies" | "leads";

/** Server-backed directory searches deliberately live outside the full-list
 * roots. Updating a full list must not blindly insert a record into cached
 * search results whose query it may not match. */
export const DIRECTORY_SEARCH_QUERY_KEY = ["directory-search"] as const;

export function directorySearchQueryKey(entity: DirectoryEntity, surface: string, query: string) {
    return [...DIRECTORY_SEARCH_QUERY_KEY, entity, surface, query] as const;
}

export function directorySearchRootQueryKey(entity: DirectoryEntity) {
    return [...DIRECTORY_SEARCH_QUERY_KEY, entity] as const;
}
